<template>
  <a-layout style="height: 100%" class="basic-layout">
    <global-header />
    <a-layout style="overflow-x: hidden; margin-top: -1px">
      <wmsSiderbar v-if="currentApp === 'material'" />
      <sidebar v-else />
      <a-layout-content>
        <tags-view v-if="true" class="tags" />
        <app-main />
        <!-- <div
          style="text-align: center; line-height: 1; color: rgba(0,0,0,.45)"
        >Copyright &copy; 2020 无锡微茗智能科技有限公司</div> -->
      </a-layout-content>
      <quick-drawer />
    </a-layout>
  </a-layout>
</template>

<script>
import { Sidebar, GlobalHeader, AppMain, TagsView } from './components/index'
import wmsSiderbar from './components/Sidebar/wmsSiderbar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BasicLayout',
  components: {
    Sidebar,
    GlobalHeader,
    AppMain,
    TagsView,
    wmsSiderbar
  },
  data() {
    return {
      collapsed: false,
      visible: false
    }
  },
  computed: {
    ...mapGetters(['currentApp'])
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-layout {
  background-color: #f0f2f5 !important;
}
/deep/ .ant-btn-primary {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
}

/deep/ .ant-btn-primary:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
}
</style>
